<template>
  <div class="article-content"
       v-bind="$attrs">
    <p class="article-section"
       :class="{'chat-style':chatStyle}"
       :style="{fontSize:fontSize+'px'}">
      {{articleSetion}}
    </p>
    <div class="article-section-button">
      <!--  -->
      <div class="article-date"
           v-if="chatStyle">
        <span>{{dateTime}}</span>
      </div>
      <!--  -->
      <div class="article-button">
        <el-button type="text"
                   v-if="chatStyle&&_getPermission()"
                   @click="replyMsg">回复</el-button>
        <el-button type="text"
                   @click="ontranslate">查看翻译</el-button>
      </div>
    </div>
    <div class="comment-more"
         v-if="chatStyle&&isMore"
         v-loading="moreLoading"
         element-loading-spinner="el-icon-loading">
      <a @click="getMore"
         v-if="commentCount>0">{{moreText}}</a>
    </div>
    <transition name="fade">
      <p class="article-translate"
         :class="{'chat-style':chatStyle}"
         :style="{fontSize:fontSize+'px'}"
         v-loading="loading"
         v-show="translate">
        {{getTranslate}}
      </p>
    </transition>

    <p class="article-image"
       v-if="articleImgUrl">
      <img :src="articleImgUrl"
           alt="loading...">
    </p>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: 'article-content',
  props: {
    flag: String,//标记后台使用还是web端使用，web端需要验证回复的权限
    commentCount: [Number, String],
    articleSetion: String,
    articleTranslate: String,
    id: String,
    articleImgUrl: String,
    dateTime: String,
    chatStyle: {  //聊天风格
      type: Boolean,
      default: false
    },
    isMore: Boolean,
    fontSize: {
      type: [Number, String],
      default: 16
    },

  },

  data () {
    return {
      translate: false,
      loading: false,
      moreText: '查看更多评论',
      moreLoading: false,
      isHidden: true,
    }
  },
  computed: {
    ...mapGetters(['getPermission']),
    getTranslate () {
      return this.articleTranslate
    }
  },
  methods: {
    _getPermission () {
      if (this.flag === 'client') { return this.getPermission('informationreply_reply') }
      return true
    },
    ontranslate () {
      this.translate = !this.translate
      if (this.translate) {
        this.loading = true
        this.$emit('translate', this.articleSetion, () => {
          this.loading = false
        })
      }
    },
    replyMsg () {
      this.$emit('reply')
    },
    getMore () {
      this.isHidden = !this.isHidden
      if (!this.isHidden) {
        this.moreLoading = true
        this.$emit('more', this.id, this.isHidden, () => {
          this.moreLoading = false
          this.moreText = '收起评论'
        })
      } else {
        this.$emit('more', this.id, this.isHidden, () => {
          this.moreText = '查看更多评论'
        })
      }

    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/client/styles/mixin.scss";
@import "@/client/styles/variables.scss";
.article-content {
  width: 100%;
  .article-section,
  .article-translate {
    line-height: 24px;
    color: $fontColor;
    word-wrap: break-word;
  }
  .article-translate {
    margin-bottom: 16px;
  }
  .chat-style {
    background: #f1f1f1;
    box-shadow: 0px 2px 3px 0px #0000000d;
    border-radius: 6px;
    padding: 10px;
    min-width: 250px;
  }

  .article-section-button {
    display: flex;
    justify-content: space-between;
    .article-button {
      //
    }
    .article-date {
      line-height: 40px;
      span {
        font-size: $fontSize_12;
        font-weight: 400;
        color: $fontColor;
        opacity: 0.66;
      }
    }
  }
  .comment-more {
    margin-bottom: 20px;
    a {
      color: $fontColor;
      transition: color 0.3s;
      -webkit-transition: color 0.3s;
      opacity: 0.8;
    }
    a:hover {
      color: $blue;
    }
  }
  .article-image {
    img {
      max-width: 100%;
      height: auto;
      border-radius: 4px;
    }
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
<style>
.article-content .comment-more .el-loading-spinner {
  margin-top: -8px;
}
</style>
